import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "LinkListFooterModule",
    component: () =>
        __SERVER__ ? require("./link-list-footer-module-view") : import("./link-list-footer-module-view")
});

export default definition;
